/* tslint:disable */
/* eslint-disable */
/**
 * users
 * users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpdateUserPin
 */
export interface UpdateUserPin {
    /**
     * 
     * @type {string}
     * @memberof UpdateUserPin
     */
    pin: string;
}

/**
 * Check if a given object implements the UpdateUserPin interface.
 */
export function instanceOfUpdateUserPin(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "pin" in value;

    return isInstance;
}

export function UpdateUserPinFromJSON(json: any): UpdateUserPin {
    return UpdateUserPinFromJSONTyped(json, false);
}

export function UpdateUserPinFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateUserPin {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'pin': json['pin'],
    };
}

export function UpdateUserPinToJSON(value?: UpdateUserPin | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'pin': value.pin,
    };
}

